<template>
	<el-date-picker v-model="pickedRange" class="f-date-range-picker" type="daterange" unlink-panels range-separator="至" :start-placeholder="placeholder[0] || '开始日期'" :end-placeholder="placeholder[1] || '结束日期'" value-format="timestamp" :clearable="clearable" :style="{ width: width }" :picker-options="options" @change="handleChange" />
</template>

<script>
const today = new Date(new Date().toLocaleDateString()).getTime();

let nowMonthDate = new Date();
let getMonth = nowMonthDate.getMonth() + 1;
nowMonthDate.setMonth(getMonth - 2);
nowMonthDate.setDate(1);
nowMonthDate.setHours(0);
nowMonthDate.setSeconds(0);
nowMonthDate.setMinutes(0);
const lastMonth = parseInt((nowMonthDate / 1000).toString());
nowMonthDate.setMonth(getMonth - 1);
const currentMonth = parseInt((nowMonthDate / 1000).toString());
export default {
  name: "FDateRangePicker",
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    clearable: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: "240px"
    },
    disablerange: {
      type: Array,
      default() {
        return [];
      }
    },
    shortcuts: {
      type: Array,
      default() {
        return [];
      }
    },
    placeholder: {
      type: Array,
      default() {
        return ["开始日期", "结束日期"];
      }
    }
  },
  data() {
    var disabledDate = date => {
      if (this.disablerange) {
        if (this.disablerange.length === 1) {
          return date.getTime() < this.disablerange[0] * 1000;
        } else {
          return (
            date.getTime() < this.disablerange[0] * 1000 ||
            date.getTime() > this.disablerange[1] * 1000
          );
        }
      } else {
        return false;
      }
    };
    const shortcuts = [];
    const choices = [
      { text: "今天", num: 0 },
      { text: "本月", num: 1 },
      { text: "上月", num: 2 },
      { text: "最近7天", num: -7 },
      { text: "最近30天", num: -30 },
      { text: "最近3个月", num: -90 }
    ];
    if (this.shortcuts.length > 0) {
      for (const c of choices) {
        if (this.shortcuts.indexOf(c.num) > -1) {
          const _this = this;
          if (c.num == 1) {
            shortcuts.push({
              text: c.text,
              onClick(picker) {
                let recent = today;
                picker.$emit("pick", [currentMonth * 1000, recent]);
              }
            });
          } else if (c.num == 2) {
            shortcuts.push({
              text: c.text,
              onClick(picker) {
                picker.$emit("pick", [
                  lastMonth * 1000,
                  currentMonth * 1000 - 3600 * 1000 * 24
                ]);
              }
            });
          } else {
            shortcuts.push({
              text: c.text,
              onClick(picker) {
                var recent = _this.today ? today - 3600 * 1000 * 24 : today;
                picker.$emit("pick", [
                  today + 3600 * 1000 * 24 * c.num,
                  recent
                ]);
              }
            });
          }
        }
      }
    }
    if (shortcuts.length) {
      return {
        options: {
          shortcuts: shortcuts,
          disabledDate: disabledDate
        }
      };
    } else {
      return {
        options: {
          disabledDate: disabledDate
        }
      };
    }
  },
  computed: {
    pickedRange: {
      get() {
        if (this.value !== null) {
          return [
            this.value[0] ? this.value[0] * 1000 : null,
            this.value[1] ? this.value[1] * 1000 : null
          ];
        } else {
          return null;
        }
      },
      set(val) {
        if (val !== null) {
          val[0] /= 1000;
          val[1] = val[1] / 1000 + 86399;
        }
        this.$emit("input", val);
      }
    }
  },
  methods: {
    handleChange(val) {
      this.$emit("change", val);
    }
  }
};
</script>

<style lang="scss" slot-scoped>
.f-date-range-picker {
  &.el-date-editor {
    .el-range-separator {
      width: 10%;
      color: #c0c4cc;
    }
  }
}
</style>
